// extracted by mini-css-extract-plugin
export default {"container":"BaseKanban_container__47lHz","columns":"BaseKanban_columns__HiwF4","columnsContainer":"BaseKanban_columnsContainer__9RIHJ"};